import { render, staticRenderFns } from "./BotsSettings.vue?vue&type=template&id=f7526c8e&scoped=true"
import script from "./BotsSettings.vue?vue&type=script&lang=js"
export * from "./BotsSettings.vue?vue&type=script&lang=js"
import style0 from "./BotsSettings.vue?vue&type=style&index=0&id=f7526c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7526c8e",
  null
  
)

export default component.exports